var _defs, _g, _path, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _path3, _path4, _path5, _g14, _g15, _path6, _path7, _path8, _path9, _path10, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137.133,
    height: 103.15,
    viewBox: "0 0 137.133 103.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.302,
    y1: 0.298,
    x2: 0.81,
    y2: 0.84,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137.133,
    height: 103.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6,30.562C29.3,33.427,14.884,51.294,12.155,54.513,4.522,63.517.01,74.894,0,86.124V86.2a38.5,38.5,0,0,0,13.475,29.495c12.713,11.185,30.3,13.857,39.393,15.239a114.528,114.528,0,0,0,16.993,1.242h.076c11.983,0,28.067-1.835,42.574-9.623a48.592,48.592,0,0,0,7.509-4.73c9.965-7.849,15.727-20.851,15.736-34.462V83.3c-.009-15.225-7.217-31.205-23.793-41.595C99.45,33.864,82.956,30.134,67.522,30.134c-3.028,0-6.018.144-8.925.428",
    transform: "translate(0 -30.134)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.443,
    height: 103.15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.308,
    height: 48.058,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.352,
    height: 14.741,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M722.678,34.2C711.342,38.232,701.722,48.9,705.487,59.8c1.223,3.541.58,7.448,4.694,8.987,2.226.833,8.288,1.328,10.592.672,6.126-1.744,10.152-6.517,6.82-11.81-1.067-1.7-2.448-3.244-3.369-5a5.993,5.993,0,0,1-.4-5.592c1.844-3.435,7.969-4.527,11.941-4.424a14.537,14.537,0,0,1,11.459,5.521c3.144,4.251,3.941,9.422,3.481,14.357-.492,5.28-3.089,9.312-6.98,13.363-3.35,3.487-7.039,6.835-9.266,10.93a26.075,26.075,0,0,0-2.8,12.038c-.018.8-4.641,8.309-4.621,10.6,0,.324,5.243,1.4,5.621,1.4l9.619.092a.722.722,0,0,0,.776-.649c.146-11.166,4.152-21.811,14.29-29.31,3.689-2.729,7.662-4.951,10.531-8.395,4.089-4.909,6.106-9.74,5.524-15.8a25.16,25.16,0,0,0-6.862-15.362c-4.521-4.614-11.137-7.5-18.014-8.739a58.86,58.86,0,0,0-10.009-.93h-.387A46.6,46.6,0,0,0,722.678,34.2",
    transform: "translate(-704.657 -31.76)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1253.435,2289c0,4.025.015,6.775,4.189,8.069,1.15.356,5.549.346,6.843.346,5.988,0,9.307-4.542,9.307-9.677s-6.342-8.921-12.329-8.921-8.01,5.05-8.01,10.184",
    transform: "translate(-1253.435 -2278.815)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -1.666,
    y1: 0.888,
    x2: -1.665,
    y2: 0.888,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M617.395,0A46.575,46.575,0,0,0,601.99,2.438C590.654,6.471,581.033,17.143,584.8,28.044c1.223,3.541,4.051,8,8.165,9.537a11.63,11.63,0,0,0,7.122.121c6.126-1.744,10.152-6.517,6.821-11.81-1.067-1.7-2.448-3.244-3.369-5a5.993,5.993,0,0,1-.4-5.592c1.844-3.435,7.969-4.527,11.941-4.424A14.536,14.536,0,0,1,626.534,16.4c3.144,4.251,3.941,9.422,3.481,14.357-.492,5.28-3.089,9.312-6.98,13.363-3.35,3.487-7.039,6.835-9.266,10.93a26.076,26.076,0,0,0-2.8,12.038c-.018.8.3,9.122.315,11.417a.649.649,0,0,0,.685.59l9.619.092a.722.722,0,0,0,.777-.649c.146-11.166,4.151-21.811,14.291-29.31,3.689-2.729,7.662-4.951,10.531-8.395,4.089-4.909,6.106-9.74,5.524-15.8A25.159,25.159,0,0,0,645.843,9.67c-4.521-4.614-11.137-7.5-18.014-8.739A58.865,58.865,0,0,0,617.82,0h-.426Z",
    transform: "translate(-583.968 0.001)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1132.745,2280.439c0,5.135,4.854,9.3,10.842,9.3s10.842-4.162,10.842-9.3-4.854-9.3-10.842-9.3-10.842,4.162-10.842,9.3",
    transform: "translate(-1132.745 -2271.143)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.436,
    height: 24.135,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.801,
    height: 2.805,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.906,
    height: 0.98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.512,
    height: 12.018,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.488,
    height: 11.854,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.387,
    height: 12.34,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.771,
    height: 4.811,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.903,
    height: 8.243,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.905,
    height: 15.485,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1957.483,582.285l-26.775.859c-.263.008-.47.158-.461.333l.01.2c.009.173.225.306.485.3l26.776-.838c.263-.008.47-.158.462-.333l-.011-.223c-.009-.168-.213-.3-.463-.3h-.023",
    transform: "translate(-1930.247 -582.285)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: -2.988,
    y1: 48.036,
    x2: -2.986,
    y2: 48.036,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1901.718,740.067l-26.775.855c-.263.008-.47.163-.461.344l.011.209c.009.179.226.318.486.309l26.776-.833c.264-.008.47-.163.461-.344l-.012-.231c-.009-.174-.214-.31-.464-.31h-.022",
    transform: "translate(-1874.482 -740.067)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: -2.901,
    y1: 43.961,
    x2: -2.9,
    y2: 43.961,
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1904.852,806.068l-29.849.966c-.293.01-.524.166-.515.349l.011.211c.009.181.25.32.54.311l29.85-.944c.293-.009.525-.166.516-.35l-.011-.233c-.009-.175-.235-.311-.513-.311h-.028",
    transform: "translate(-1874.488 -806.068)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: -2.603,
    y1: 39.764,
    x2: -2.602,
    y2: 39.764,
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1892.087,675.317l-14.593.365c-.143,0-.251.172-.239.376l.013.235c.012.2.136.361.277.358l14.594-.341c.144,0,.251-.172.239-.376l-.015-.259c-.012-.2-.133-.358-.273-.358h0",
    transform: "translate(-1877.253 -675.317)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: -5.323,
    y1: 58.567,
    x2: -5.321,
    y2: 58.567,
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2284.516,663.576l-13.793.339c-.135,0-.237.172-.225.375l.013.235c.012.2.129.361.263.358l13.8-.315c.135,0,.236-.172.225-.375l-.015-.259c-.011-.2-.127-.358-.26-.358h0",
    transform: "translate(-2270.497 -663.576)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: -6.811,
    y1: 60.059,
    x2: -6.808,
    y2: 60.059,
    xlinkHref: "#z"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M619.042,2687.117a.976.976,0,0,0,1.019.99c2.06.073,6.466.217,8.047.156a.3.3,0,0,0,.3-.407.722.722,0,0,0-.4-.359l-7.278-2.868-1.285-.178s-.276,1.34-.411,2.666",
    transform: "translate(-619.038 -2684.451)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: -2.706,
    y1: 0.769,
    x2: -2.702,
    y2: 0.769,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.444,2656.609l.222,1.6a2.663,2.663,0,0,0,2.146-.064l-.528-1.786Z",
    transform: "translate(-623.444 -2656.362)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: -11.314,
    y1: 2.244,
    x2: -11.296,
    y2: 2.244,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.009,1852.209s-.509-10.993,0,.387c.456,10.185,3.951,20.847,4.68,22.975a.624.624,0,0,0,.62.385,7.238,7.238,0,0,0,2.078-.362.3.3,0,0,0,.213-.362c-2.551-9.172-2.133-29.638-2.037-30.057h-5.255Z",
    transform: "translate(-492.782 -1845.174)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: -0.167,
    y1: 1.329,
    x2: -0.165,
    y2: 1.329,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.413,2705.9a.576.576,0,0,0,.572.667c.68.058,1.727.132,2.566.126a.594.594,0,0,0,.642-.62,4.361,4.361,0,0,0-1.277-2.571l-1.639-.076a8.7,8.7,0,0,0-.865,2.474",
    transform: "translate(-413.4 -2703.424)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: -3.104,
    y1: 0.911,
    x2: -3.097,
    y2: 0.911,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.854,2645.007l.518,2.424a2.086,2.086,0,0,0,1.526.09l-.247-2.607Z",
    transform: "translate(-424.854 -2644.913)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: -8.93,
    y1: 2.009,
    x2: -8.909,
    y2: 2.009,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.379,1832.63c-2.087,10.8.453,26.689,1.309,29.8a.538.538,0,0,0,.457.368,4.414,4.414,0,0,0,1.632-.056.463.463,0,0,0,.373-.409c.115-2.514-.092-17.951,1.852-24.052a1.406,1.406,0,0,1,.623-.764l3.774-2.3.289-3.718Z",
    transform: "translate(-373.575 -1831.497)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: -0.069,
    y1: 1.235,
    x2: -0.068,
    y2: 1.235,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.211,1283.92a67.981,67.981,0,0,0-13.153,1.408c-1.864,9.326-.326,20.083-.326,20.083,4.841,1.089,10.3-.666,10.3-.666.8-3.9,4.559-14.869,4.559-14.869a23.078,23.078,0,0,0,7.645-2.08,10.854,10.854,0,0,1-2.65-4.753,24.218,24.218,0,0,1-6.377.877",
    transform: "translate(-374.135 -1283.043)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: -0.26,
    y1: 1.991,
    x2: -0.259,
    y2: 1.991,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f52ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042e2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M860.894,1081.483c-.92,3.333-5.745,6.036-10.7,7.357a10.853,10.853,0,0,0,2.65,4.753,17.079,17.079,0,0,0,9.444-11.775,1.286,1.286,0,0,0-.949-.406,1.342,1.342,0,0,0-.443.071",
    transform: "translate(-850.192 -1081.412)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: -1.946,
    y1: 4.643,
    x2: -1.944,
    y2: 4.643,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1099.412,944.721c-.239.28,0,1.751.02,2.095.438.717,1.183.45,1.118.275a1.76,1.76,0,0,0,1.247-.631,12.6,12.6,0,0,0,.769-1.078,1.261,1.261,0,0,0,.167-1.06,4.742,4.742,0,0,0-.7-1.187l1.2-1.071a.455.455,0,0,0-.074-.7,29.93,29.93,0,0,0-3.746,3.358",
    transform: "translate(-1099.308 -941.363)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: -5.478,
    y1: 12.173,
    x2: -5.473,
    y2: 12.173,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1117.47,1009.106l-.343.79.974.927a9.542,9.542,0,0,1,.571-1.908c.243-.34.117-.5-.11-.6Z",
    transform: "translate(-1117.127 -1008.312)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: -13.801,
    y1: 26.509,
    x2: -13.788,
    y2: 26.509,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.288,1352.772a15.691,15.691,0,0,1,5.078,1.167c.432-2.037,4.122-3.692,4.122-3.692l-2.4-5.192s-5.841,3.4-6.8,7.718",
    transform: "translate(-237.288 -1345.054)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: -0.589,
    y1: 4.857,
    x2: -0.586,
    y2: 4.857,
    xlinkHref: "#av"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.078,1558.636c3.876,6.08,14.417-.336,14.417-.336l-.868-1.387s-6.558,3.178-8.771.465a1.9,1.9,0,0,1-.456-1.657,15.689,15.689,0,0,0-5.078-1.167,5.224,5.224,0,0,0,.755,4.082",
    transform: "translate(-234.19 -1554.554)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: -0.641,
    y1: 4.515,
    x2: -0.638,
    y2: 4.515,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.041,1559.542a6.751,6.751,0,0,0,.3,2.382,2.068,2.068,0,0,0,1.706-.511c.392-.329.624-.658.941-.481a.715.715,0,0,0,.972-.192l-.569-.539c.834.348.921-.3.921-.3l-.612-.406c.987.262,1.065-.55,1.065-.55a21.53,21.53,0,0,0-2.831-.647,2.559,2.559,0,0,0-.351-.025,1.54,1.54,0,0,0-1.539,1.273",
    transform: "translate(-563.993 -1558.269)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: -4.892,
    y1: 12.178,
    x2: -4.883,
    y2: 12.178,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M507.755,1193.6a.167.167,0,0,0,.094.214,5.346,5.346,0,0,0,4.851-.28.837.837,0,0,0,.45-.6l.644-4.27h-4.05Z",
    transform: "translate(-507.743 -1188.669)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: -3.589,
    y1: 9.655,
    x2: -3.582,
    y2: 9.655,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.387,1065.95l1.652,3.808c2.365,1.157,5.072,1.259,5.352-.165s-1.9-4.952-1.9-4.952Z",
    transform: "translate(-536.387 -1064.642)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: -2.131,
    y1: 7.519,
    x2: -2.127,
    y2: 7.519,
    xlinkHref: "#al"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.085,995.782a.187.187,0,0,1-.269,0,1.9,1.9,0,0,0-2.129-.593c-1,.384-1.111,1.012-1.1,1.328a.162.162,0,0,1-.2.148,2.091,2.091,0,0,0-2.283.912c-.466.878-.163,1.375.113,1.618a.138.138,0,0,1-.072.241.888.888,0,0,0-.718,1c.059.922,1.261.841,1.6.8a.187.187,0,0,1,.151.045,5.951,5.951,0,0,0,3.046,1.6.154.154,0,0,0,.179-.194l-.619-1.544a.14.14,0,0,1,.092-.181l.307-.117a.137.137,0,0,0,.074-.213,3.586,3.586,0,0,1-.608-1.107s-.393-.216,1-.5,3.469-.729,3.905-1.746c.31-.723-.2-2.244-1.192-2.244a1.828,1.828,0,0,0-1.284.747",
    transform: "translate(-466.428 -995.035)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: -1.36,
    y1: 5.994,
    x2: -1.356,
    y2: 5.994,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "bp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.083,1146.721c-.114.771,1.4,1.116,2.151.829l-.482-.685a3.4,3.4,0,0,0-1.266-.453.352.352,0,0,0-.4.309",
    transform: "translate(-544.077 -1146.412)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: -8.891,
    y1: 25.585,
    x2: -8.875,
    y2: 25.585,
    xlinkHref: "#al"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.11)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,172.329,23.533l23.544,162.133L23.544,162.133Z",
    transform: "matrix(0.779, -0.627, 0.627, 0.779, -66.625, 40.135)",
    fill: "#f4f7fa",
    opacity: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.738 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1730.215,1142.275a.8.8,0,0,1-.514-.26c-1.8-2.085-14.921-18.4,2.536-33.311,16.572-14.157,24.084-17.063,25.083-25.381a1.191,1.191,0,0,1,2.152-.329c3.765,6.545,9.632,21.816-9.783,31.839-21.417,11.057-19.661,23.178-18.626,26.622.137.455-.3.883-.848.82",
    transform: "translate(-1649.245 -1042.573)",
    fill: "#91b3fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1917.37,2230.061a1.045,1.045,0,0,1-.949-.8c-.511-2.837-1.767-13.438,7.341-16.249,10.026-3.094,18.12,4.912,25.49-1.354.387-.33,1.04-.043.947.419-.656,3.274-3.577,10.856-16.577,12.382-13.913,1.633-15.479,3-15.2,4.7a.874.874,0,0,1-1.054.9",
    transform: "translate(-1833.743 -2130.05)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.289 48.969)",
    opacity: 0.47,
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1807.066,1329.518a11.058,11.058,0,0,1-.666,1.771,16.888,16.888,0,0,1-.9,1.682,21.935,21.935,0,0,1-2.313,3.13,28.648,28.648,0,0,1-6.17,5.185,40.88,40.88,0,0,1-3.62,2.013,33.736,33.736,0,0,0-3.437,1.974,34.388,34.388,0,0,0-5.951,4.929,24.932,24.932,0,0,0-6.814,12.768,21.339,21.339,0,0,0-.046,7.107,26.16,26.16,0,0,0,2.2,6.918.223.223,0,0,1-.15.3.293.293,0,0,1-.347-.116,25.112,25.112,0,0,1-2.621-6.979,20.808,20.808,0,0,1-.244-7.376,22.609,22.609,0,0,1,2.322-7.134,28.4,28.4,0,0,1,4.514-6.319,34.248,34.248,0,0,1,6.179-5.179,35.336,35.336,0,0,1,3.593-2.08c1.224-.6,2.385-1.214,3.51-1.91a32.028,32.028,0,0,0,6.107-4.776,25.642,25.642,0,0,0,2.47-2.862,18.036,18.036,0,0,0,1.911-3.159l.006-.014a.262.262,0,0,1,.32-.121.207.207,0,0,1,.152.246",
    transform: "translate(-1775.764 -1329.257)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.036 83.585)",
    opacity: 0.47,
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1932.825,2283.411a.651.651,0,0,0,.026-.3l-.011-.292-.008-.585c0-.389.011-.779.031-1.168a22.5,22.5,0,0,1,.239-2.329,15.508,15.508,0,0,1,1.383-4.536,8.608,8.608,0,0,1,3.388-3.716,8.2,8.2,0,0,1,2.6-.916,11.078,11.078,0,0,1,2.788-.121c3.622.361,7.172.956,10.731,1.439a22.045,22.045,0,0,0,5.312.225,9.054,9.054,0,0,0,1.273-.25,7.3,7.3,0,0,0,1.188-.455,8.219,8.219,0,0,0,2.017-1.439h0a.248.248,0,0,1,.312-.013.171.171,0,0,1,.019.265,8.619,8.619,0,0,1-2.1,1.559,7.846,7.846,0,0,1-1.271.515,9.567,9.567,0,0,1-1.36.293,22.612,22.612,0,0,1-5.485-.176c-1.8-.219-3.574-.505-5.356-.752s-3.574-.488-5.343-.666a10.32,10.32,0,0,0-2.608.092,7.556,7.556,0,0,0-2.4.824,8.2,8.2,0,0,0-3.262,3.464,15.256,15.256,0,0,0-1.445,4.413,22.289,22.289,0,0,0-.285,2.3q-.042.577-.055,1.155l0,.578,0,.289a.55.55,0,0,0,.053.285.165.165,0,0,1-.088.237.223.223,0,0,1-.276-.075.153.153,0,0,1-.011-.14Z",
    transform: "translate(-1932.812 -2268.908)",
    fill: "#fff"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.273 1.17)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,108,8.083l8.242,107.483-108-8.083Z",
    transform: "matrix(0.761, -0.649, 0.649, 0.761, -48.526, 33.322)",
    fill: "#e8627d"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.849 83.95)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,27.784,2.079l2.09,27.257L2.09,27.257Z",
    transform: "matrix(0.761, -0.649, 0.649, 0.761, -10.714, 7.831)",
    fill: "url(#j)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.088 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,107.956,8.3,116.2,116.454l-107.956-8.3Z",
    transform: "translate(-49.033 41.86) rotate(-46.64)",
    fill: "url(#a)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.664 83.667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,28.228,2.171,30.4,30.833,2.171,28.662Z",
    transform: "translate(-10.788 10.222) rotate(-47.856)",
    fill: "url(#a)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.947 2.842)",
    opacity: 0.63,
    style: {
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M674.356,101.275a.136.136,0,0,1-.136-.094c-.76-2.942-.871-7.548,2.912-12.789a26.256,26.256,0,0,1,15.4-10.172c6.973-1.748,15.252-1.373,24.607,1.112a.117.117,0,0,1,.092.149.145.145,0,0,1-.174.079c-17.973-4.775-32.065-1.594-39.683,8.958-3.734,5.172-3.625,9.713-2.877,12.612a.12.12,0,0,1-.106.142l-.03,0",
    transform: "translate(-673.796 -77.14)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.125 28.905)",
    opacity: 0.63,
    style: {
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702.874,787.426a.148.148,0,0,1-.112-.049,11.507,11.507,0,0,1-1.541-2.595.115.115,0,0,1,.081-.154.147.147,0,0,1,.179.069,11.532,11.532,0,0,0,1.506,2.539.109.109,0,0,1-.03.167.154.154,0,0,1-.082.023",
    transform: "translate(-701.211 -784.621)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.367 85.958)",
    opacity: 0.63,
    style: {
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1385.635,2334.323a.158.158,0,0,1-.063-.013,8.881,8.881,0,0,0-3.565-.728.121.121,0,1,1,0-.239,9.2,9.2,0,0,1,3.691.754.112.112,0,0,1,.061.16.143.143,0,0,1-.124.065",
    transform: "translate(-1381.868 -2333.343)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.337 86.775)",
    opacity: 0.63,
    style: {
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1198.626,2367.528a.157.157,0,0,1-.078-.021,6.792,6.792,0,0,1-3.6-5.809,6.935,6.935,0,0,1,4.307-6.175.151.151,0,0,1,.188.049.111.111,0,0,1-.057.162,6.7,6.7,0,0,0-4.161,5.964,6.562,6.562,0,0,0,3.479,5.611.109.109,0,0,1,.037.166.147.147,0,0,1-.115.053",
    transform: "translate(-1194.946 -2355.51)",
    fill: "#fff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.025 14.484)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.734,396.092a.366.366,0,0,1-.462.042c-.274-.19-.561-.373-.854-.543a.258.258,0,0,1-.091-.386l0,0a.363.363,0,0,1,.456-.075c.308.179.611.371.9.571a.255.255,0,0,1,.069.372l-.02.024m-2.808-1.246c-.317-.134-.644-.258-.972-.368a.27.27,0,0,1-.186-.365.348.348,0,0,1,.425-.159c.345.116.689.246,1.023.388a.264.264,0,0,1,.149.377.271.271,0,0,1-.019.029.361.361,0,0,1-.42.1m-2.618-.811c-.343-.07-.694-.128-1.043-.173a.291.291,0,0,1-.276-.32.325.325,0,0,1,.373-.237c.368.047.737.108,1.1.182a.283.283,0,0,1,.243.339.262.262,0,0,1-.044.088.355.355,0,0,1-.351.12m-2.764-.289c-.353,0-.711.008-1.062.031a.316.316,0,0,1-.352-.259.3.3,0,0,1,.3-.3c.37-.024.747-.035,1.118-.033a.306.306,0,0,1,.325.284.252.252,0,0,1-.053.151.345.345,0,0,1-.278.128m-2.77.247c-.344.065-.69.143-1.028.232a.341.341,0,0,1-.41-.186.276.276,0,0,1,.217-.352c.355-.094.719-.176,1.082-.244a.332.332,0,0,1,.391.215.248.248,0,0,1-.045.213.331.331,0,0,1-.205.121m-2.638.766c-.32.128-.637.27-.942.421a.359.359,0,0,1-.448-.1.261.261,0,0,1,.12-.384c.322-.159.656-.308.992-.444a.353.353,0,0,1,.436.135.247.247,0,0,1-.022.273.317.317,0,0,1-.136.1m-7.395,8.3a.291.291,0,0,1-.276-.32c.055-.315.128-.632.215-.942a.334.334,0,0,1,.4-.208.282.282,0,0,1,.242.339c-.083.295-.151.6-.2.894a.257.257,0,0,1-.049.111.351.351,0,0,1-.324.125m5.022-7.056c-.278.186-.55.385-.808.59a.368.368,0,0,1-.464-.015.255.255,0,0,1,.017-.4c.272-.217.559-.426.851-.622a.366.366,0,0,1,.461.049.25.25,0,0,1,.016.326.3.3,0,0,1-.073.068m-4.351,4.672a.27.27,0,0,1-.185-.365c.136-.3.289-.591.454-.877a.354.354,0,0,1,.44-.127.264.264,0,0,1,.148.377c-.157.272-.3.552-.432.833a.271.271,0,0,1-.03.05.359.359,0,0,1-.4.108m2.363-3c-.222.235-.436.48-.635.731a.363.363,0,0,1-.456.074.258.258,0,0,1-.091-.386l0,0c.209-.264.434-.523.668-.769a.367.367,0,0,1,.462-.041.255.255,0,0,1,.068.371l-.021.024",
    transform: "translate(-50.319 -393.183)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.756,688.374a.251.251,0,0,0,.053-.162c-.005-.145-.007-.292-.006-.438a.332.332,0,0,0-.656-.005c0,.154,0,.309.006.461a.311.311,0,0,0,.338.273.343.343,0,0,0,.265-.128",
    transform: "translate(-47.146 -676.648)",
    fill: "#91b3fa"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.843 24.601)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.989,903.456a.253.253,0,0,0-.055-.362c-.126-.1-.251-.2-.372-.3a.368.368,0,0,0-.464,0,.254.254,0,0,0,0,.4c.128.108.26.214.392.317a.368.368,0,0,0,.463-.02.294.294,0,0,0,.032-.036",
    transform: "translate(-136.004 -894.059)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.907,726.5a.365.365,0,0,1-.458.063.256.256,0,0,1-.074-.393c.2-.24.4-.491.576-.749a.361.361,0,0,1,.45-.1.26.26,0,0,1,.112.386q-.118.168-.241.33c-.117.155-.24.309-.365.457m.993-2a.268.268,0,0,1-.171-.37c.138-.274.263-.556.373-.838a.343.343,0,0,1,.415-.178.274.274,0,0,1,.207.356c-.116.3-.248.594-.393.882a.266.266,0,0,1-.026.042.36.36,0,0,1-.4.1m-2.136,3.183c-.252.226-.519.447-.793.654a.367.367,0,0,1-.463-.025.255.255,0,0,1,.029-.4c.261-.2.514-.406.753-.621a.368.368,0,0,1,.464-.009.253.253,0,0,1,.049.356.294.294,0,0,1-.038.041m3.027-5.471a.287.287,0,0,1-.262-.329c.064-.293.114-.591.149-.887a.319.319,0,0,1,.359-.252.3.3,0,0,1,.293.308c-.037.312-.09.626-.157.935a.259.259,0,0,1-.047.1.353.353,0,0,1-.336.123m-5.237,7.059c-.3.173-.621.338-.941.489a.358.358,0,0,1-.445-.111.262.262,0,0,1,.13-.382c.3-.144.606-.3.894-.464a.363.363,0,0,1,.455.079.248.248,0,0,1,0,.309.3.3,0,0,1-.094.081m-2.563,1.134c-.341.112-.692.214-1.043.3a.339.339,0,0,1-.407-.192.278.278,0,0,1,.224-.349c.333-.083.667-.179.991-.286a.347.347,0,0,1,.424.162.247.247,0,0,1-.031.254.321.321,0,0,1-.157.109m-2.79.628c-.362.046-.73.079-1.095.1a.315.315,0,0,1-.348-.263.3.3,0,0,1,.307-.3c.346-.019.7-.05,1.04-.094a.324.324,0,0,1,.373.237.248.248,0,0,1-.049.194.336.336,0,0,1-.227.125m-2.883.091c-.365-.023-.733-.06-1.094-.109a.29.29,0,0,1-.272-.322.326.326,0,0,1,.376-.233c.343.047.692.082,1.039.1a.3.3,0,0,1,.3.3.255.255,0,0,1-.052.132.348.348,0,0,1-.3.128m-2.838-.455c-.349-.091-.7-.2-1.038-.313a.27.27,0,0,1-.183-.366.349.349,0,0,1,.426-.157c.323.111.654.211.986.3a.277.277,0,0,1,.218.351.262.262,0,0,1-.039.071.357.357,0,0,1-.371.116m-2.649-.977c-.234-.114-.467-.235-.692-.36q-.122-.068-.242-.138a.255.255,0,0,1-.086-.391.363.363,0,0,1,.456-.074q.114.066.23.131c.214.119.435.235.658.343a.261.261,0,0,1,.124.383l-.01.015a.362.362,0,0,1-.437.091",
    transform: "translate(-175.001 -718.79)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.776,668.679a.25.25,0,0,0,.053-.163c-.006-.152-.017-.307-.031-.461a.316.316,0,0,0-.352-.259.3.3,0,0,0-.3.3c.013.146.023.293.029.438a.312.312,0,0,0,.34.271.342.342,0,0,0,.263-.128",
    transform: "translate(-619.441 -667.795)",
    fill: "#91b3fa"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.879,475.989a.152.152,0,0,0-.143-.091l-1.866-.035a7.376,7.376,0,0,0-1.7-1.724l.266-1.583a.128.128,0,0,0-.082-.136l-1.991-.878a.173.173,0,0,0-.176.022l-1.348,1.106a9.437,9.437,0,0,0-2.625-.186L132.1,471.2a.169.169,0,0,0-.17-.047l-2.132.586a.136.136,0,0,0-.107.122l-.041,1.6a7.949,7.949,0,0,0-2.01,1.459l-1.846-.228a.161.161,0,0,0-.158.07l-1.025,1.707a.118.118,0,0,0,.026.151l1.29,1.156a6.011,6.011,0,0,0-.216,2.251l-1.495.959a.121.121,0,0,0-.054.145l.683,1.828a.152.152,0,0,0,.143.091l1.866.035a7.376,7.376,0,0,0,1.7,1.724l-.266,1.583a.128.128,0,0,0,.082.136l1.991.878a.173.173,0,0,0,.176-.022l1.348-1.106a9.441,9.441,0,0,0,2.625.186l1.118,1.282a.169.169,0,0,0,.17.046l2.132-.586a.136.136,0,0,0,.106-.122l.041-1.6a7.951,7.951,0,0,0,2.01-1.459l1.846.228a.161.161,0,0,0,.158-.07l1.024-1.707a.118.118,0,0,0-.026-.151l-1.29-1.155a6.015,6.015,0,0,0,.216-2.251l1.495-.959a.121.121,0,0,0,.054-.145Z",
    transform: "translate(-118.817 -453.793)",
    fill: "#91b3fa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.711,648a2.522,2.522,0,0,1-3.176.171,1.83,1.83,0,0,1-.758-1.326,1.754,1.754,0,0,1,.558-1.4,2.522,2.522,0,0,1,3.176-.171,1.742,1.742,0,0,1,.4,2.5,2,2,0,0,1-.2.226m-3.41-1.183a1.4,1.4,0,0,0,.581,1.017,1.934,1.934,0,0,0,2.435-.131,1.339,1.339,0,0,0-.153-2.088,1.934,1.934,0,0,0-2.435.131,1.549,1.549,0,0,0-.155.175,1.313,1.313,0,0,0-.273.9",
    transform: "translate(-284.98 -621.046)",
    fill: "#bdd0fb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M230.388,575.966a4.725,4.725,0,0,0,.285-.422q.041-.069.08-.139a4.376,4.376,0,0,0,.315-.71l0-.01.009-.028.018-.055a.106.106,0,0,0-.055-.124.149.149,0,0,0-.038-.014.135.135,0,0,0-.161.079,4.174,4.174,0,0,1-.406.9,5.357,5.357,0,0,1-4.21,2.432,5.991,5.991,0,0,1-2.889-.481q-.243-.107-.469-.233a4.639,4.639,0,0,1-2.138-2.406,3.917,3.917,0,0,1,.333-3.447,5.726,5.726,0,0,1,7.1-1.95q.239.105.463.23a4.927,4.927,0,0,1,1.6,1.4.124.124,0,0,0,.04.035.15.15,0,0,0,.141,0,.1.1,0,0,0,.042-.155,5.172,5.172,0,0,0-1.681-1.471q-.235-.131-.486-.242a6.013,6.013,0,0,0-7.452,2.047,4.112,4.112,0,0,0-.349,3.619,4.871,4.871,0,0,0,2.245,2.526q.237.132.493.245a6.329,6.329,0,0,0,4.22.3,5.472,5.472,0,0,0,2.946-1.925",
    transform: "translate(-210.757 -547.682)",
    fill: "#bdd0fb"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.074 10.547)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M840.958,347.211a.155.155,0,0,0-.016-.208c-.112-.112-.229-.223-.349-.329a.227.227,0,0,0-.286,0,.157.157,0,0,0,0,.246c.114.1.226.207.333.313a.227.227,0,0,0,.286.019.186.186,0,0,0,.038-.037",
    transform: "translate(-826.22 -344.399)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.414,288.187a.226.226,0,0,1-.285.026c-.22-.152-.452-.3-.688-.428l-.151-.082a.16.16,0,0,1-.065-.239.232.232,0,0,1,.279-.056l.158.086c.248.138.491.289.722.449a.158.158,0,0,1,.043.23l-.012.014m-2.031-.9a9.278,9.278,0,0,0-.958-.321.17.17,0,0,1-.131-.219.212.212,0,0,1,.255-.112,9.691,9.691,0,0,1,1,.336.165.165,0,0,1,.1.231.17.17,0,0,1-.014.022.223.223,0,0,1-.255.063m-1.956-.537a9.647,9.647,0,0,0-1.021-.109.186.186,0,0,1-.19-.184.194.194,0,0,1,.215-.163,10.138,10.138,0,0,1,1.071.114.177.177,0,0,1,.162.2.161.161,0,0,1-.029.063.218.218,0,0,1-.207.076m-2.05-.109a9.7,9.7,0,0,0-1.021.109.2.2,0,0,1-.237-.139.178.178,0,0,1,.162-.2,10.172,10.172,0,0,1,1.071-.114.194.194,0,0,1,.215.163.156.156,0,0,1-.032.105.211.211,0,0,1-.158.079m-2.019.324a9.338,9.338,0,0,0-.96.318.218.218,0,0,1-.269-.086.164.164,0,0,1,.1-.23,9.809,9.809,0,0,1,1.006-.333.211.211,0,0,1,.255.113.153.153,0,0,1-.023.147.2.2,0,0,1-.108.071m-1.866.734a8.419,8.419,0,0,0-.839.509.226.226,0,0,1-.285-.027.158.158,0,0,1,.031-.244,8.847,8.847,0,0,1,.88-.534.223.223,0,0,1,.279.056.153.153,0,0,1,0,.186.19.19,0,0,1-.063.053m-1.6,1.1a7.582,7.582,0,0,0-.669.671.226.226,0,0,1-.284.034.159.159,0,0,1-.04-.243,8,8,0,0,1,.7-.7.227.227,0,0,1,.287,0,.156.156,0,0,1,.029.219.187.187,0,0,1-.025.026m-1.96,2.289a.166.166,0,0,1-.108-.228,7.175,7.175,0,0,1,.411-.722c.023-.036.046-.071.07-.106a.22.22,0,0,1,.277-.063.161.161,0,0,1,.074.237c-.022.033-.044.066-.066.1a6.841,6.841,0,0,0-.393.69.174.174,0,0,1-.017.027.222.222,0,0,1-.249.065",
    transform: "translate(-513.807 -286.291)",
    fill: "#91b3fa"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29 17.302)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.461,509.358a7.8,7.8,0,0,1-.642.724.227.227,0,0,1-.286.018.158.158,0,0,1-.022-.245,7.412,7.412,0,0,0,.612-.691.224.224,0,0,1,.281-.048.159.159,0,0,1,.058.239l0,0m.263-.709a.163.163,0,0,1-.089-.233,6.764,6.764,0,0,0,.4-.8.214.214,0,0,1,.26-.1.168.168,0,0,1,.121.223,7.111,7.111,0,0,1-.422.835l-.011.016a.223.223,0,0,1-.261.06m-1.645,2.086a8.7,8.7,0,0,1-.827.57.225.225,0,0,1-.283-.041.159.159,0,0,1,.048-.242,8.333,8.333,0,0,0,.789-.544.227.227,0,0,1,.286.012.155.155,0,0,1,.02.211.178.178,0,0,1-.034.034m2.4-3.74a.175.175,0,0,1-.152-.208,6.225,6.225,0,0,0,.167-.856.2.2,0,0,1,.222-.155.183.183,0,0,1,.18.191,6.479,6.479,0,0,1-.175.9.162.162,0,0,1-.027.056.219.219,0,0,1-.216.075m-4.127,4.79a9.571,9.571,0,0,1-.963.383.215.215,0,0,1-.263-.1.167.167,0,0,1,.115-.225,9.065,9.065,0,0,0,.918-.365.221.221,0,0,1,.275.07.153.153,0,0,1-.009.177.2.2,0,0,1-.073.058m-1.972.663a10.194,10.194,0,0,1-1.042.174.2.2,0,0,1-.228-.149.181.181,0,0,1,.174-.2,9.718,9.718,0,0,0,.994-.166.208.208,0,0,1,.247.125.153.153,0,0,1-.026.138.2.2,0,0,1-.119.074m-2.1.239a10.2,10.2,0,0,1-1.06-.045.182.182,0,0,1-.179-.192.2.2,0,0,1,.224-.153,9.654,9.654,0,0,0,1.011.043.191.191,0,0,1,.2.172.154.154,0,0,1-.033.1.212.212,0,0,1-.168.079",
    transform: "translate(-675.038 -504.445)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.95,470.375a.156.156,0,0,0,.033-.1c0-.149-.012-.3-.025-.444a.2.2,0,0,0-.218-.16.185.185,0,0,0-.186.187c.013.139.021.281.024.423a.191.191,0,0,0,.206.17.212.212,0,0,0,.166-.079",
    transform: "translate(-886.08 -469.673)",
    fill: "#91b3fa"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M561.743,340.932a.1.1,0,0,0-.1-.061l-1.249-.023a4.933,4.933,0,0,0-1.139-1.154l.178-1.059a.086.086,0,0,0-.055-.091l-1.332-.588a.116.116,0,0,0-.118.015l-.9.74a6.319,6.319,0,0,0-1.757-.124l-.748-.858a.113.113,0,0,0-.113-.031l-1.427.392a.091.091,0,0,0-.071.082l-.028,1.071a5.318,5.318,0,0,0-1.345.977l-1.235-.153a.108.108,0,0,0-.106.047l-.686,1.142a.079.079,0,0,0,.017.1l.863.773a4.022,4.022,0,0,0-.145,1.506l-1,.641a.081.081,0,0,0-.036.1l.457,1.223a.1.1,0,0,0,.1.061l1.249.024a4.935,4.935,0,0,0,1.139,1.154l-.178,1.059a.085.085,0,0,0,.055.091l1.332.588a.116.116,0,0,0,.118-.015l.9-.74a6.319,6.319,0,0,0,1.757.124l.748.858a.113.113,0,0,0,.113.031l1.427-.392a.091.091,0,0,0,.071-.082l.027-1.071a5.318,5.318,0,0,0,1.345-.977l1.235.153a.108.108,0,0,0,.106-.047l.686-1.142a.079.079,0,0,0-.017-.1l-.863-.773a4.025,4.025,0,0,0,.145-1.506l1-.641a.081.081,0,0,0,.036-.1Z",
    transform: "translate(-525.616 -325.254)",
    fill: "#91b3fa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M667.467,455.446a1.627,1.627,0,0,1-1.054.443,1.686,1.686,0,0,1-1.11-.326,1.19,1.19,0,0,1-.136-1.855,1.718,1.718,0,0,1,2.163-.117,1.246,1.246,0,0,1,.516.9,1.166,1.166,0,0,1-.242.8,1.375,1.375,0,0,1-.138.155m-1.9-.144a1.241,1.241,0,0,0,.817.24,1.2,1.2,0,0,0,.775-.326.88.88,0,0,0,.279-.7.917.917,0,0,0-.38-.664,1.264,1.264,0,0,0-1.591.086,1.018,1.018,0,0,0-.1.113.873.873,0,0,0,.2,1.252",
    transform: "translate(-636.225 -436.565)",
    fill: "#bdd0fb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M617.84,405.253a3.278,3.278,0,0,0,.195-.288,3.031,3.031,0,0,0,.284-.621l.009-.029a.163.163,0,0,0-.085-.191.222.222,0,0,0-.058-.022.208.208,0,0,0-.248.123,2.694,2.694,0,0,1-.262.581h0l-.019.03a3.109,3.109,0,0,1-1.118,1.065,3.7,3.7,0,0,1-.826.344l-.007,0-.022.006a3.9,3.9,0,0,1-2.6-.185q-.157-.069-.3-.151a3,3,0,0,1-1.384-1.558,2.536,2.536,0,0,1,.216-2.232,3.307,3.307,0,0,1,1.993-1.447,3.9,3.9,0,0,1,2.6.185q.155.068.3.149a3.19,3.19,0,0,1,1.037.907.19.19,0,0,0,.062.054.231.231,0,0,0,.217,0,.16.16,0,0,0,.065-.239,3.569,3.569,0,0,0-1.16-1.015q-.162-.09-.335-.167a4.366,4.366,0,0,0-2.912-.207,3.693,3.693,0,0,0-2.229,1.619,2.836,2.836,0,0,0-.241,2.5,3.36,3.36,0,0,0,1.549,1.743q.163.091.34.169a4.207,4.207,0,0,0,4.946-1.125",
    transform: "translate(-584.58 -385.449)",
    fill: "#bdd0fb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1680.894,857.776,1675,862.945l7.069-1.619Z",
    transform: "translate(-1603.041 -826.176)",
    fill: "#91b3fa"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1847.236,526.659l-33.485,1.393a1.424,1.424,0,0,1-1.58-1.291V514.949a2.582,2.582,0,0,1,2.685-2.375l30.179-.8a3.813,3.813,0,0,1,4.069,3.489v9.715a1.824,1.824,0,0,1-1.868,1.682",
    transform: "translate(-1734.318 -492.92)",
    fill: "#4d50fb"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.367 19.173)",
    opacity: 0.85,
    style: {
      isolation: "isolate"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1826.209,535.941a2.244,2.244,0,0,1-1.426-.491,1.652,1.652,0,0,1-.641-1.285V523.519a2.534,2.534,0,0,1,2.671-2.307l29.219-.757c2.215,0,4.015,1.507,4.015,3.359v9.179a1.815,1.815,0,0,1-1.879,1.651l-31.858,1.294-.1,0m29.825-15.361-29.218.757a2.4,2.4,0,0,0-2.53,2.182v10.647a1.534,1.534,0,0,0,.6,1.195,2.094,2.094,0,0,0,1.42.454l31.858-1.294a1.68,1.68,0,0,0,1.74-1.527v-9.179c0-1.784-1.735-3.235-3.867-3.235",
    transform: "translate(-1824.142 -520.456)",
    fill: "#fff"
  })))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.926 21.451)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.751,
    height: 1.701,
    transform: "translate(-0.008 0)",
    fill: "url(#z)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.53 27.263)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.752,
    height: 1.726,
    transform: "translate(-0.009 0)",
    fill: "url(#ab)"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.53 29.695)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.934,
    height: 1.847,
    transform: "translate(-0.009)",
    fill: "url(#ad)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.649 24.878)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.148,
    height: 1.336,
    transform: "translate(-0.011 0)",
    fill: "url(#af)"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.543 24.446)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.32,
    height: 1.31,
    transform: "translate(-0.011 0)",
    fill: "url(#ah)"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.595 98.893)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,9.009.693l.714,9.4L.714,9.4Z",
    transform: "translate(-2.299 2.099) rotate(-47.406)",
    fill: "url(#aj)"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.784 97.858)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.367,
    height: 2.359,
    transform: "translate(0)",
    fill: "url(#al)"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.171 67.975)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,33.987,2.549l2.084,29.073L2.084,29.073Z",
    transform: "translate(-19.643 18.542) rotate(-53.58)",
    fill: "url(#an)"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.76 99.592)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,5.03.387l.387,5.1L.387,5.1Z",
    transform: "translate(-1.965 1.774) rotate(-47.406)",
    fill: "url(#ap)"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.252 97.436)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.044,
    height: 2.845,
    transform: "translate(0)",
    fill: "url(#ar)"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.049 67.471)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,33.427,2.507l2.159,30.121L2.159,30.121Z",
    transform: "matrix(0.594, -0.805, 0.805, 0.594, -18.777, 20.331)",
    fill: "url(#at)"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.073 47.266)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,31.92,2.21,34.056,35.5l-31.92-2.21Z",
    transform: "matrix(0.502, -0.865, 0.865, 0.502, -12.818, 17.546)",
    fill: "url(#av)"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.525 39.838)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,15.194.773l.716,15.857L.716,15.857Z",
    transform: "translate(-4.429 10.852) rotate(-70.71)",
    fill: "url(#ax)"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.228 34.679)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,7.2.366,7.489,6.8.29,6.431Z",
    transform: "matrix(0.33, -0.944, 0.944, 0.33, -2.378, 5.496)",
    fill: "url(#az)"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.993 37.145)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,3.027.194l.165,2.822L.165,2.822Z",
    transform: "translate(-1.166 2.016) rotate(-63.631)",
    fill: "url(#bb)"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.194 49.551)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,12.132.84l.814,12.685L.814,12.685Z",
    transform: "matrix(0.502, -0.865, 0.865, 0.502, -4.498, 6.646)",
    fill: "url(#bd)"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.061 57.268)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.462,
    height: 10.162,
    transform: "translate(-0.156)",
    fill: "url(#bf)"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.582,1424.258l3.579-10.717a.353.353,0,0,1,.308-.225c.649-.065,2.527-.247,4.7-.4a62.065,62.065,0,0,1,7.461-.213.314.314,0,0,1,.3.451c-1.031,1.789-5.273,9.066-7.4,11.45a.391.391,0,0,1-.3.124l-8.3-.066a.326.326,0,0,1-.348-.4",
    transform: "translate(-527.872 -1360.609)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.341,1384.762l2.595-.371c.138-.02.251.094.207.208l-.257.667a.181.181,0,0,1-.152.108l-2.5.286a.172.172,0,0,1-.206-.195l.159-.583a.177.177,0,0,1,.151-.121",
    transform: "translate(-720.675 -1333.389)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.023,1404.077l.214-.955a.246.246,0,0,1,.227-.178l5.241-.456a.236.236,0,0,1,.276.271l-.333,1.19a.251.251,0,0,1-.237.169l-5.122.221a.235.235,0,0,1-.266-.262",
    transform: "translate(-684.3 -1350.821)",
    fill: "#bdd0fb"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.23 57.405)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.921,
    height: 3.756,
    transform: "translate(-0.153 0)",
    fill: "url(#bi)"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.813 43.79)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.072,
    height: 6.149,
    transform: "translate(-0.021 0)",
    fill: "url(#bk)"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.044 39.221)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bl)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,9.088.642l.639,9.7L.639,9.7Z",
    transform: "translate(-3.305 4.647) rotate(-58.62)",
    fill: "url(#bm)"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.038 36.656)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bn)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,12.136.922,13.058,13.5.922,12.578Z",
    transform: "matrix(0.62, -0.785, 0.785, 0.62, -4.642, 4.741)",
    fill: "url(#bo)"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.374 42.233)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,2.328.165l.177,2.691L.177,2.691Z",
    transform: "translate(-0.846 1.039) rotate(-58.62)",
    fill: "url(#bq)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/qa.add598ff7b8b543c24d8fd35969253eb.svg";
export { ForwardRef as ReactComponent };